import React, { useMemo } from 'react';
import styles from './BackgroundEffect.module.scss';

interface BackgroundEffectMobileProps extends React.HTMLAttributes<HTMLDivElement> {
  ref?: React.Ref<HTMLDivElement>;
}

export const BackgroundEffectMobile: React.FC<BackgroundEffectMobileProps> = ({
  className = '',
  style,
  ref,
  ...props
}) => {
  const rays = useMemo(() => {
    return Array.from({ length: 4 }, (_, index) => {
      return {
        id: `ray-${index}`,
        delay: index * 2,
        duration: 6 + Math.sin(index) * 2,
      };
    });
  }, []);

  return (
    <div
      ref={ref}
      className={`${styles.backgroundEffectContainer} ${className}`}
      style={style}
      {...props}
    >
      <div className={styles.radialGradient} />
      <div className={styles.raysContainer}>
        {rays.map((ray) => (
          <div
            key={ray.id}
            className={styles.ray}
            style={{
              '--ray-delay': `${ray.delay}s`,
            } as React.CSSProperties}
          />
        ))}
      </div>
      <div className={styles.dotPattern} />
    </div>
  );
};

export default BackgroundEffectMobile;
